export default process.env.COOKIE_POLICY || 'https://politicacookies.angellira.com.br/?hiddenLogo=true';